import { render, staticRenderFns } from "./coupon-card.vue?vue&type=template&id=50f2609a&scoped=true&"
import script from "./coupon-card.vue?vue&type=script&lang=js&"
export * from "./coupon-card.vue?vue&type=script&lang=js&"
import style0 from "./coupon-card.vue?vue&type=style&index=0&id=50f2609a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f2609a",
  null
  
)

export default component.exports